import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectReportsByAvailability } from 'store/seatingChart/selectors';

interface TicketAvailabilityLabelProps {
  limit: number | null;
  total: number | null;
  seatsCategoryKey: string;
  displaySoldFromDate: boolean;
}

const TicketAvailabilityLabel: React.FC<TicketAvailabilityLabelProps> = ({
  limit,
  total,
  seatsCategoryKey,
  displaySoldFromDate,
}) => {
  const { t } = useTranslation();
  const reportsByAvailability = useSelector(selectReportsByAvailability);
  const report = reportsByAvailability?.find(
    report => report.categoryKey === seatsCategoryKey,
  );
  const availableTickets = report ? report.available : limit;
  const totalTickets = report ? report.total : total;

  // this boolean indicates that ticket is upcoming, thus we don't want to display quantity
  if (displaySoldFromDate) return null;

  if (totalTickets === null || availableTickets === null) {
    // we don't want to display anything until reports are fetched
    return seatsCategoryKey ? (
      <></>
    ) : (
      <span className="neutral-label"> {t('ticketSale.unlimited')} </span>
    );
  }

  if (availableTickets === 0) {
    return <p className="red-label">{t('common.soldOut')}</p>;
  }

  const categoryIsMostlySold = availableTickets <= totalTickets * 0.2;

  return (
    <p className={categoryIsMostlySold ? 'red-label' : 'green-label'}>
      {categoryIsMostlySold
        ? seatsCategoryKey
          ? t('ticketSale.lastSeats', { limit: availableTickets })
          : t('ticketSale.lastTickets', { limit: availableTickets })
        : seatsCategoryKey
        ? t('ticketSale.availableSeats', { limit: availableTickets })
        : t('ticketSale.availableTickets', { limit: availableTickets })}
    </p>
  );
};

export default TicketAvailabilityLabel;
